module.exports = __webpack_public_path__ + "img/pauli-x.844b6c7b.svg";